import React, { useState, useEffect, useRef, useContext } from "react";
import { Alert } from "reactstrap";
import Pagination from '../../components/pagination/pagination';
import LabelsTable from "../../components/labelsTable";
import TableModal from "../../components/tableModal";
import ViewLayout from "../../components/viewLayout";
import TableHelper from "../../components/tableHelper";
import { getCookie } from "../../jwt/_helpers/cookie";
import { getUser } from "../../utils/getUser";
import { useFetch } from "../../utils/fetchHook";
import { StateContext } from "../../utils/context";
import { Trans, useTranslation } from "react-i18next";

const Labels = props => {
  const token = getCookie("token");
  const {currentUser, setCurrentUser} = useContext(StateContext);
  const { t } = useTranslation();

  const [openModal, setToggleModal] = useState(false);
  const [dataModal, setDataModal] = useState(null);

  const didEff1 = useRef(false);
  const didEff2 = useRef(false);
  const [forceUpdate, setForce] = useState(1);
  const [dataCount, setDataCount] = useState(0);
  const [currrentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [query, setQuery] = useState('');
  const [ordering, setOrdering] = useState({order: '', name: 'name', sort: 'name'});
  const [subUser, setSubUser] = useState('');
  const [subUserEndpoint, setSubUserEndpoint] = useState('');
  const [parentUserOnly, setParentUserOnly] = useState('');
  const [apiData, error, loading] = useFetch("GET",`labels/${subUserEndpoint}?ordering=${ordering.order + ordering.name}&page=${currrentPage}&page_size=${pageSize}&search=${query}${parentUserOnly}`,token,false,forceUpdate);
  const [tableData, setTableData] = useState([]);

  //ajax handlers
  const [success, setSuccess] = useState(false);
  const [errorPut, setError] = useState(false);

  useEffect(() => {

    if (apiData?.detail === "Invalid page.") {
      setCurrentPage(1);
      return;
    }

    if (apiData) {
      if(apiData.count) {
        setDataCount(apiData.count);
      }
      if(apiData.results) {
        setTableData(apiData.results);
      }
    }
  }, [apiData]);


  useEffect(() => {
    if (!didEff1.current) {
      didEff1.current = true;
      return;
    }
    setForce(prev => prev + 1);
  }, [currrentPage, pageSize, ordering.order, ordering.name, subUser]);

  useEffect(() => {
    getUser(token, currentUser, setCurrentUser);
  }, [success, errorPut]);

  useEffect(() => {
    if (!didEff2.current) {
      didEff2.current = true;
      return;
    }
    const timeout = setTimeout(() => {
      setForce(prev => prev + 1);
    }, 500)
    return () => clearTimeout(timeout)
  }, [query])

  const paginationProps = {
    pageSize, setPageSize, dataCount, setCurrentPage, currrentPage
  }

  const defaultSorted = [{
    dataField: ordering.sort,
    order: ordering.order === "-" ? "desc" : "asc"
  }] 

  const handlerValues = { setSuccess, setError, forceUpdate, setForce };

  return (
    <>
      {loading ? (
        <TableHelper loading />
      ) : error ? (
        <TableHelper error />
      ) :  (
        <div>
          {
            (currentUser.labels_enabled && (!currentUser.has_subscription || !currentUser.subscription_active || !currentUser.is_paid_subscription)) &&
            <Alert color="danger">
              <Trans i18nKey="labels.view.message.notSubscribed">
                Your are not subscribed to any plan, therefore you can only add <b>3 Labels</b>, Please <a href="/dashboard/">subscribe</a> to a plan to avail unlimited amount of labels.
              </Trans>
            </Alert>
          }
          {
            (!currentUser.labels_enabled && currentUser.subscription_active && currentUser.has_subscription) &&
            <Alert color="danger">
              <Trans i18nKey="labels.view.message.subscriptionUpgrade">
                Your current subscription plan does not support this feature. Please <a href="/subscription/upgrade/">upgrade</a> your subscription plan to avail this feature.
              </Trans>
            </Alert>
          }
          {
            (!currentUser.labels_enabled && !currentUser.subscription_active && currentUser.has_subscription) &&
            <Alert color="danger">
              <Trans i18nKey="labels.view.message.subscriptionExpired">
                Your subscription has expired. Please <a href="/subscription/">resume</a> your subscription to avail this feature.
              </Trans>
            </Alert>
          }
          { 
            (!currentUser.labels_enabled && !currentUser.has_subscription) &&
            <Alert color="danger">
              <Trans i18nKey="labels.view.message.noAccess">
                You don't have access to this module, please contact the support team for further information.
              </Trans>
            </Alert>
          }
          {
            (currentUser.labels_enabled) &&
            <>
              <ViewLayout title={t("labels.view.table.title")}>
                <LabelsTable
                  setToggleModal={setToggleModal}
                  setDataModal={setDataModal}
                  forceUpdate={forceUpdate}
                  setForce={setForce}
                  data={tableData}
                  defaultSorted={defaultSorted}
                  searchQuery={{setQuery, query, ordering, setOrdering}}
                  subUserData={{subUser, setSubUser, subUserEndpoint, setSubUserEndpoint, setParentUserOnly}}
                />
              </ViewLayout>
              <Pagination pagination={paginationProps}/>
            </>
          }
        </div>
      ) }
        
      
      {dataModal && (
        <TableModal
          openModal={openModal}
          setToggleModal={setToggleModal}
          dataModal={dataModal}
          values={handlerValues}
          title={t("labels.view.modal.delete.header", {labelName: dataModal.name})}
          body={t("labels.view.modal.delete.body", {labelName: dataModal.name})}
          apiURL={`labels/${dataModal.id}`}
          bodyID={dataModal.id}
        />
      )}
      {success && <Alert color="success">{t("labels.view.message.success")}</Alert>}
      {errorPut && (
        <Alert color="danger">
          {t("labels.view.message.error")}
        </Alert>
      )}
    </>
  );
};

export default Labels;
